var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgFileCross = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "5 6 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop-User-Profile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-User-Profile---Icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Location-/-Black-Background"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(9.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-1",
    stroke: "currentColor",
    points: "11.884 11 11.884 0 3.284 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-3",
    stroke: "currentColor",
    points: "11.884 10.2755 11.884 14.8005 0 14.8005 0 3.6535"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-5",
    stroke: "currentColor",
    points: "3.3615 0.0001 3.3615 3.6541 0.0005 3.6541 0.0005 3.2291 2.9635 0.0001"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(6.000000, 8.000000) rotate(45.000000) translate(-6.000000, -8.000000) translate(3.000000, 5.000000)",
    fill: "#383E41"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    points: "0 3.5 6 3.5 6 2.5 0 2.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    points: "2.5 6 3.5 6 3.5 0 2.5 0"
  }))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFileCross, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/fileCross.7be3889c.svg";
export { ForwardRef as ReactComponent };